import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Description from '../../text/Description';
import { LinkAnchor } from '../../Links';

const bgImg = (imageObj) => {
    if (imageObj && imageObj.oneX && imageObj.twoX && imageObj.threeX) {
        return (
            <img
                src={imageObj.default}
                srcSet={`${imageObj.oneX} 2x, ${imageObj.twoX} 3x`}
                style={{ left: '0%' }}
            />
        );
    } if (imageObj && imageObj.default) {
        return (
            <img
                src={imageObj.default}
                style={{ left: '0%' }}
            />
        );
    }
    return null;
};

class FeaturedProEventCard extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { title, image, copy, overlayPercent, link, 'data-testid': dataTestId } = this.props;
        const bgOpacity = overlayPercent ? `0.${100 - parseInt(overlayPercent)}` : '1';

        return (
            <LinkAnchor link={link} data-testid={dataTestId && `${dataTestId}.card-link`}>
                <div className={`utr-card pro-event-card event-card-featured`}>
                    <div className={`card-view left-gradiant`}>
                        <div className="d-flex flex-row ">
                            <div className="event-content">
                                <div className="d-flex align-self-stretch">
                                    <div className="flex-grow">
                                        <div className="tag-container mb-auto">
                                            <div className={`tag tag-featured tag-sm mr8`} data-testid={dataTestId && `${dataTestId}.featured-tag`}>Featured</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="empty-div" />
                                <div className="event-name" data-testid={dataTestId && `${dataTestId}.name`}>
                                    {title}
                                </div>
                                <div className="event-details show-ellipsis" data-testid={dataTestId && `${dataTestId}.details`}>
                                    <Description desc={copy} data-testid={dataTestId && `${dataTestId}.details`} />
                                </div>
                            </div>
                            <div className={`backgroundWrapper`}>
                                {
                                    image &&
                                    (
                                        <picture className={`d-none d-sm-block img`} style={{ opacity: bgOpacity }}>
                                            {bgImg(image.desktop)}
                                        </picture>
                                    )
                                }
                                {
                                    image &&
                                    (
                                        <picture className={`d-block d-sm-none img`} style={{ opacity: bgOpacity }}>
                                            {bgImg(image.mobile)}
                                        </picture>
                                    )
                                }
                                <div className="backgroundOverlay" />
                            </div>
                        </div>
                    </div>
                </div>
            </LinkAnchor>
        );
    }
}

FeaturedProEventCard.propTypes = {
    'data-testid': PropTypes.string,
};

FeaturedProEventCard.defaultProps = {
    'data-testid': null,
};

export default FeaturedProEventCard;
